import React, { useCallback } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";

import { Grid } from "@material-ui/core";
import * as Yup from "yup";

import { ReportJobAction } from "actions/reportJob";
import {
  getEndDateValidation,
  getStartDateValidation,
} from "components/MultiSaleReports/commonValidation";
import {
  BulkReportFormProps,
  ModalActions,
} from "components/MultiSaleReports/ManyReportsForm/BulkReportFormCommon";
import {
  ExcludeZeroBalanceSelect,
  ExcludeZeroBalanceFormValues,
  excludeZeroBalanceValidation,
  FinancialStatementForm,
  FinancialStatementFormValues,
} from "./Form";

export const validationSchema = Yup.object().shape({
  startDate: getStartDateValidation("endDate", { isYearOptionAllowed: true }),
  endDate: getEndDateValidation(),
  excludeZeroBalance: excludeZeroBalanceValidation,
});

type SupportedReportType =
  | "FinancialStatementReport"
  | "FinancialStatementZipReport";

type FormValueType = {
  report: SupportedReportType;
} & FinancialStatementFormValues &
  ExcludeZeroBalanceFormValues;

interface FormProps extends BulkReportFormProps {
  reportSlug: SupportedReportType;
}

export function CreateFinancialStatementReportJobsForm(
  props: FormProps,
): React.JSX.Element {
  const { reportSlug, onClose } = props;

  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (values: FormValueType) => {
      dispatch(ReportJobAction.createBulk(values));
      onClose();
    },
    [dispatch, onClose],
  );

  const initialValues: FormValueType = {
    report: reportSlug,
    startDate: null,
    endDate: null,
    excludeZeroBalance: null,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Grid container spacing={2}>
          <FinancialStatementForm namespace="" />
          <ExcludeZeroBalanceSelect />
        </Grid>
        <ModalActions onClose={onClose} allowInitialSubmit={false} />
      </Form>
    </Formik>
  );
}
